import { Injectable } from "@angular/core";
import * as Sentry from "@sentry/angular";

@Injectable({
    providedIn: 'root'
})
export class SentryLoggerService {

    setTag(key: string, value: string | number | boolean): void {
        Sentry.setTag(`ca_${key}`, value);
    }
}
